import { IdName } from 'app/shared/models/standard.models';

export class Activity {
  public id: string | undefined;
  public subject: string | undefined;
  public activityType = new IdName();
  public activityIcon: string | undefined;
  public status: IdName  = new IdName();
  public companyId: string | undefined;
  public customer: ActivityCustomer | undefined;
  public customerName: string | undefined;
  public caseId: string | undefined;
  public offerId: string | undefined;
  public propertyId: string | undefined;
  public propertyLeaseId: string | undefined;
  public dueDate: string | undefined;
  public dueTime: string | undefined;
  public dueDateTime: string | undefined;
  public description: string | undefined;
  public durationInMinutes: number | undefined;
  public assignedToStakeholder = new ActivityIdName();
  public partnerCompanyId: string | undefined;
  public mandatory: boolean | undefined;
  public createdBy: ActivityIdName | undefined;
  public modifiedBy: ActivityIdName | undefined;
  public createdAt: string | undefined;
  public lastModified: string | undefined;
  public recurring: number | undefined;
  public recurrance: string | undefined;
  public note: string | undefined;
  public dvAccountPlanId: string | undefined;
  public dvCategoryId: string | undefined;
  priorityId?:string
}

export class NewActivity {
  public subject: string | undefined;
  public activityType: string | undefined;
  public activityName: string | undefined;
  public activityIcon: string | undefined;
  public status: string | undefined;
  public customerId: string | null = null;
  public customerName: string | undefined;
  public caseId: string | null = null;
  public offerId: string | null = null;
  public propertyId:string | null = null;
  public propertyLeaseId: string | null = null;
  public dueDate: string | undefined;
  public dueTime: string | undefined;
  public dueDateTime:string | undefined;
  public description: string | undefined;
  public durationInMinutes: number | undefined;
  public assignedToStakeholder: string | undefined;
  public partnerCompanyId: string | null = null;
  public mandatory: boolean | undefined;
  public recurring: number | undefined;
  public recurrance: string | undefined;
  public note: string = '';
  public dvAccountPlanId: string | undefined;
  public dvCategoryId: string | undefined;
  priorityId: string | null = null;
}


export class ActivityIdName {
  id!: string;
  name!: string;
}

export class ActivityCustomer {
  customerId!: string;
  name!: string;
}

export class ActivityType {
  id!: string | null;
  name!: string| null;
  icon: string = "fas fa-question";
  sort: number = 0;
}

export class ActivityInput {
  customerId?: string;
  caseId?: string;
  offerId?: string;
  propertyId?: string;
  propertyLeaseId?: string;
}
